(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["counter-display"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('counter-display')) {
    customElements.define(
      'counter-display',
      class CounterDisplay extends HTMLElement {
        connectedCallback() {
          this.ticker = this.querySelector('[data-counter-ticker]');
          this.track = this.querySelector('[data-counter-track]');
          this.valueEl = this.querySelector('[data-counter-value]');
          if (!this.ticker || !this.track || !this.valueEl) return;

          this.count = 0;
          this.speed = Math.max(1, Number(this.dataset.speed) || 5);
          this.rafId = null;
          this.lastTick = 0;
          this.measureSize = 100;

          this.fit = this.fit.bind(this);
          this.tick = this.tick.bind(this);

          // Scale type so label + arrow + counter fill the guttered width
          this.resizeObserver = new ResizeObserver(this.fit);
          this.resizeObserver.observe(this.ticker);

          if (document.fonts?.ready) {
            document.fonts.ready.then(() => {
              if (this.isConnected) this.fit();
            });
          }

          this.fit();

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.valueEl.textContent = '0000';
            return;
          }

          this.rafId = requestAnimationFrame(this.tick);
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();

          if (this.rafId !== null) {
            cancelAnimationFrame(this.rafId);
            this.rafId = null;
          }
        }

        fit() {
          if (!this.track || !this.ticker) return;

          this.track.style.width = '100%';
          const available = this.track.clientWidth;
          if (available <= 0) return;

          // Measure intrinsic line width at a known font size, then scale to fit
          this.track.style.fontSize = `${this.measureSize}px`;
          this.track.style.width = 'max-content';
          this.track.style.justifyContent = 'flex-start';

          const contentWidth = this.track.scrollWidth;

          this.track.style.width = '100%';
          this.track.style.justifyContent = '';

          if (contentWidth <= 0) return;

          this.track.style.fontSize = `${this.measureSize * (available / contentWidth)}px`;
        }

        tick(timestamp) {
          if (!this.lastTick) this.lastTick = timestamp;

          const elapsed = timestamp - this.lastTick;
          if (elapsed >= this.speed) {
            const steps = Math.floor(elapsed / this.speed);
            this.count = (this.count + steps) % 10000;
            this.valueEl.textContent = String(this.count).padStart(4, '0');
            this.lastTick += steps * this.speed;
          }

          this.rafId = requestAnimationFrame(this.tick);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-video')) {
    customElements.define(
      'featured-video',
      class FeaturedVideo extends HTMLElement {
        connectedCallback() {
          this.control = this.querySelector('.featured-video__control');
          this.videos = Array.from(this.querySelectorAll('video'));
          this.labelPlay = this.dataset.labelPlay || 'Play video';
          this.labelPause = this.dataset.labelPause || 'Pause video';
          this.youtubeItem = this.querySelector('[data-youtube-id]');
          this.youtubeFrame = null;
          this.youtubePlaying = false;

          this.handleControlClick = this.handleControlClick.bind(this);
          this.handlePlay = this.handlePlay.bind(this);
          this.handlePlaying = this.handlePlaying.bind(this);
          this.handlePause = this.handlePause.bind(this);

          this.control?.addEventListener('click', this.handleControlClick);

          this.videos.forEach((video) => {
            if (this.hasAttribute('data-muted')) {
              video.muted = true;
            }

            video.addEventListener('play', this.handlePlay);
            video.addEventListener('playing', this.handlePlaying);
            video.addEventListener('pause', this.handlePause);
          });

          if (this.hasAttribute('data-autoplay')) {
            this.playActive();
          } else {
            this.pauseAll();
            this.setPlaying(false);
          }
        }

        disconnectedCallback() {
          this.control?.removeEventListener('click', this.handleControlClick);

          this.videos.forEach((video) => {
            video.removeEventListener('play', this.handlePlay);
            video.removeEventListener('playing', this.handlePlaying);
            video.removeEventListener('pause', this.handlePause);
          });
        }

        startYoutube() {
          if (!this.youtubeItem || this.youtubeFrame) return;

          const id = this.youtubeItem.dataset.youtubeId;
          const params = new URLSearchParams({
            autoplay: '1',
            controls: '0',
            loop: '1',
            playlist: id,
            playsinline: '1',
            rel: '0',
            enablejsapi: '1',
            origin: window.location.origin,
          });

          if (this.hasAttribute('data-muted')) {
            params.set('mute', '1');
          }

          const frame = document.createElement('iframe');
          frame.className = 'featured-video__youtube';
          frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?' + params.toString();
          frame.title = this.dataset.labelPlayer || 'Video player';
          frame.allow = 'autoplay; encrypted-media; picture-in-picture';
          frame.allowFullscreen = true;
          frame.addEventListener('load', () => this.setAttribute('data-started', ''), { once: true });

          this.youtubeFrame = frame;
          this.youtubeItem.appendChild(frame);
        }

        sendYoutubeCommand(func) {
          this.youtubeFrame?.contentWindow?.postMessage(
            JSON.stringify({ event: 'command', func, args: [] }),
            'https://www.youtube-nocookie.com',
          );
        }

        toggleYoutube() {
          if (!this.youtubeFrame) {
            this.startYoutube();
            this.youtubePlaying = true;
          } else if (this.youtubePlaying) {
            this.sendYoutubeCommand('pauseVideo');
            this.youtubePlaying = false;
          } else {
            this.sendYoutubeCommand('playVideo');
            this.youtubePlaying = true;
          }

          this.setPlaying(this.youtubePlaying);
        }

        getActiveVideo() {
          return (
            this.videos.find((video) => {
              const item = video.closest('.featured-video__media-item');
              if (!item) return true;
              return getComputedStyle(item).display !== 'none';
            }) || this.videos[0]
          );
        }

        handleControlClick() {
          if (this.youtubeItem) {
            this.toggleYoutube();
            return;
          }

          const video = this.getActiveVideo();
          if (!video) return;

          if (video.paused) {
            this.playActive();
          } else {
            this.pauseAll();
          }
        }

        playActive() {
          if (this.youtubeItem) {
            if (!this.youtubePlaying) this.toggleYoutube();
            return;
          }

          const video = this.getActiveVideo();
          if (!video) return;

          this.videos.forEach((item) => {
            if (item !== video && !item.paused) {
              item.pause();
            }
          });

          const playPromise = video.play();
          if (playPromise?.catch) {
            playPromise.catch(() => {});
          }
        }

        pauseAll() {
          if (this.youtubeItem) {
            if (this.youtubePlaying) this.toggleYoutube();
            return;
          }

          this.videos.forEach((video) => {
            if (!video.paused) {
              video.pause();
            }
          });
        }

        handlePlay(event) {
          const active = this.getActiveVideo();
          if (event.target === active) {
            this.setPlaying(true);
          }
        }

        handlePlaying() {
          this.setAttribute('data-started', '');
        }

        handlePause(event) {
          const active = this.getActiveVideo();
          if (event.target === active) {
            this.setPlaying(false);
          }
        }

        setPlaying(playing) {
          if (playing) {
            this.setAttribute('data-playing', '');
            this.control?.setAttribute('aria-pressed', 'true');
            this.control?.setAttribute('aria-label', this.labelPause);
            return;
          }

          this.removeAttribute('data-playing');
          this.control?.setAttribute('aria-pressed', 'false');
          this.control?.setAttribute('aria-label', this.labelPlay);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const activateMegaMenuFeature = (event) => {
    const link = event.target.closest('[data-mega-image]');

    if (!link) return;

    const panel = link.closest('.header__mega-menu-panel');

    if (!panel) return;

    const handle = link.getAttribute('data-mega-image');

    panel.querySelectorAll('.header__mega-menu-feature').forEach((feature) => {
      feature.classList.toggle('is-active', feature.getAttribute('data-mega-image') === handle);
    });
  };

  document.querySelectorAll('.header__mega-menu-panel').forEach((panel) => {
    panel.addEventListener('pointerover', activateMegaMenuFeature);
    panel.addEventListener('focusin', activateMegaMenuFeature);
  });

  const loadMegaMenuImages = (panel) => {
    panel.querySelectorAll('img[data-src]').forEach((image) => {
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      image.src = image.dataset.src;
      delete image.dataset.src;
      delete image.dataset.srcset;
    });
  };

  document.querySelectorAll('.has-megamenu').forEach((item) => {
    const panel = item.querySelector('.header__mega-menu-panel');

    if (!panel) return;

    const load = () => loadMegaMenuImages(panel);

    item.addEventListener('pointerenter', load, { once: true });
    item.addEventListener('focusin', load, { once: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["positioned-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('positioned-text')) {
    customElements.define(
      'positioned-text',
      class PositionedText extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-strip-viewport]');
          this.track = this.querySelector('[data-strip-track]');

          if (!this.viewport || !this.track) return;

          // Snapshot source items so we can rebuild clones on resize
          this.sourceItems = Array.from(this.track.querySelectorAll('[data-strip-item]')).map((item) =>
            item.cloneNode(true)
          );

          if (!this.sourceItems.length) return;

          this.fill = this.fill.bind(this);
          this.resizeObserver = new ResizeObserver(this.fill);
          this.resizeObserver.observe(this.viewport);
          this.fill();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        appendSet(isClone) {
          this.sourceItems.forEach((node) => {
            const clone = node.cloneNode(true);

            // Keep theme-editor hooks only on the first sequence
            if (isClone) {
              clone.setAttribute('aria-hidden', 'true');
              clone.getAttributeNames().forEach((name) => {
                if (name.startsWith('data-shopify')) {
                  clone.removeAttribute(name);
                }
              });
            }

            this.track.appendChild(clone);
          });
        }

        fill() {
          const viewportWidth = this.viewport.clientWidth;
          if (!viewportWidth) return;

          this.track.replaceChildren();
          this.appendSet(false);

          const firstItem = this.track.querySelector('[data-strip-item]');
          // Target half an item past the viewport edge so the strip reads as overflowing
          const overflowTarget = viewportWidth + (firstItem?.offsetWidth || 0) * 0.5;

          let setsAdded = 1;
          while (this.track.scrollWidth < overflowTarget && setsAdded < 40) {
            this.appendSet(true);
            setsAdded += 1;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scrolling-marquee')) {
    customElements.define(
      'scrolling-marquee',
      class ScrollingMarquee extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-marquee-viewport]');
          this.groups = Array.from(this.querySelectorAll('[data-marquee-group]'));

          if (!this.viewport || this.groups.length < 2) return;

          // Snapshot each group's original items so we can rebuild on resize
          this.itemSets = this.groups.map((group) =>
            Array.from(group.querySelectorAll('[data-marquee-item]')).map((item) => item.cloneNode(true))
          );

          if (!this.itemSets[0].length) return;

          this.fill = this.fill.bind(this);
          this.resizeObserver = new ResizeObserver(this.fill);
          this.resizeObserver.observe(this.viewport);
          this.fill();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        fill() {
          const minWidth = this.viewport.clientWidth;
          if (!minWidth) return;

          this.groups.forEach((group, groupIndex) => {
            const source = this.itemSets[groupIndex];
            group.replaceChildren();

            let setsAdded = 0;
            do {
              source.forEach((node) => {
                const clone = node.cloneNode(true);

                // Keep theme-editor hooks only on the first set of the first group
                if (groupIndex > 0 || setsAdded > 0) {
                  clone.getAttributeNames().forEach((name) => {
                    if (name.startsWith('data-shopify')) {
                      clone.removeAttribute(name);
                    }
                  });
                }

                group.appendChild(clone);
              });
              setsAdded += 1;
            } while (group.scrollWidth < minWidth && setsAdded < 40);
          });

          this.setAttribute('data-ready', '');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tabbed-content')) {
    customElements.define(
      'tabbed-content',
      class TabbedContent extends HTMLElement {
        connectedCallback() {
          this.triggers = Array.from(
            this.querySelectorAll('[data-tabbed-trigger]')
          );
          this.panels = Array.from(this.querySelectorAll('[data-tabbed-panel]'));
          if (!this.triggers.length) return;

          this.mediaQuery = window.matchMedia('(min-width: 1024px)');
          this.onMediaChange = this.onMediaChange.bind(this);
          this.onClick = this.onClick.bind(this);
          this.onKeydown = this.onKeydown.bind(this);

          this.addEventListener('click', this.onClick);
          this.addEventListener('keydown', this.onKeydown);

          if (this.mediaQuery.addEventListener) {
            this.mediaQuery.addEventListener('change', this.onMediaChange);
          } else {
            this.mediaQuery.addListener(this.onMediaChange);
          }

          this.syncMode(true);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          this.removeEventListener('keydown', this.onKeydown);

          if (!this.mediaQuery) return;

          if (this.mediaQuery.removeEventListener) {
            this.mediaQuery.removeEventListener('change', this.onMediaChange);
          } else {
            this.mediaQuery.removeListener(this.onMediaChange);
          }
        }

        get isDesktop() {
          return this.mediaQuery.matches;
        }

        onMediaChange() {
          this.syncMode(true);
        }

        syncMode(reset) {
          if (this.isDesktop) {
            this.setAttribute('data-mode', 'tabs');
            if (reset) this.activate(0);
          } else {
            this.setAttribute('data-mode', 'accordion');
            if (reset) this.activate(-1);
          }
        }

        onClick(event) {
          const trigger = event.target.closest('[data-tabbed-trigger]');
          if (!trigger || !this.contains(trigger)) return;

          const index = Number(trigger.dataset.tabbedIndex);
          if (Number.isNaN(index)) return;

          if (this.isDesktop) {
            this.activate(index);
            return;
          }

          const isOpen = trigger.classList.contains('is-active');
          this.activate(isOpen ? -1 : index);
        }

        onKeydown(event) {
          if (!this.isDesktop) return;

          const trigger = event.target.closest('[data-tabbed-trigger]');
          if (!trigger || !this.contains(trigger)) return;

          const currentIndex = Number(trigger.dataset.tabbedIndex);
          if (Number.isNaN(currentIndex)) return;

          let nextIndex = currentIndex;

          switch (event.key) {
            case 'ArrowDown':
            case 'ArrowRight':
              nextIndex = (currentIndex + 1) % this.triggers.length;
              break;
            case 'ArrowUp':
            case 'ArrowLeft':
              nextIndex =
                (currentIndex - 1 + this.triggers.length) % this.triggers.length;
              break;
            case 'Home':
              nextIndex = 0;
              break;
            case 'End':
              nextIndex = this.triggers.length - 1;
              break;
            default:
              return;
          }

          event.preventDefault();
          this.activate(nextIndex);
          this.triggers[nextIndex]?.focus();
        }

        activate(activeIndex) {
          this.triggers.forEach((trigger, index) => {
            const panel = this.panels[index];
            const isActive = index === activeIndex;

            trigger.classList.toggle('is-active', isActive);
            panel?.classList.toggle('is-active', isActive);
            trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
            trigger.setAttribute(
              'tabindex',
              isActive || !this.isDesktop ? '0' : '-1'
            );

            if (this.isDesktop) {
              trigger.setAttribute('role', 'tab');
              trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
              panel?.setAttribute('role', 'tabpanel');
            } else {
              trigger.removeAttribute('role');
              trigger.removeAttribute('aria-selected');
              panel?.setAttribute('role', 'region');
            }

            if (panel) {
              panel.hidden = !isActive;
            }
          });

          const tabs = this.querySelector('.tabbed-content__tabs');
          if (!tabs) return;

          if (this.isDesktop) {
            tabs.setAttribute('role', 'tablist');
            tabs.setAttribute('aria-orientation', 'vertical');
          } else {
            tabs.removeAttribute('role');
            tabs.removeAttribute('aria-orientation');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('team-showcase')) {
    customElements.define(
      'team-showcase',
      class TeamShowcase extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-marquee-viewport]');
          this.groups = Array.from(this.querySelectorAll('[data-marquee-group]'));

          if (!this.viewport || this.groups.length < 2) return;

          // Snapshot each group's original items so we can rebuild on resize
          this.itemSets = this.groups.map((group) =>
            Array.from(group.querySelectorAll('[data-marquee-item]')).map((item) => item.cloneNode(true))
          );

          if (!this.itemSets[0].length) return;

          this.fill = this.fill.bind(this);
          this.resizeObserver = new ResizeObserver(this.fill);
          this.resizeObserver.observe(this.viewport);
          this.fill();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        fill() {
          const minWidth = this.viewport.clientWidth;
          if (!minWidth) return;

          this.groups.forEach((group, groupIndex) => {
            const source = this.itemSets[groupIndex];
            group.replaceChildren();

            let setsAdded = 0;
            do {
              source.forEach((node) => {
                const clone = node.cloneNode(true);

                // Keep theme-editor hooks only on the first set of the first group
                if (groupIndex > 0 || setsAdded > 0) {
                  clone.getAttributeNames().forEach((name) => {
                    if (name.startsWith('data-shopify')) {
                      clone.removeAttribute(name);
                    }
                  });
                }

                group.appendChild(clone);
              });
              setsAdded += 1;
            } while (group.scrollWidth < minWidth && setsAdded < 40);
          });

          this.setAttribute('data-ready', '');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
